export default class VideoTestimonials {
  constructor() {
    const $els = document.querySelectorAll('.js-video-testimonials .js-video-card');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    $el.querySelector('.js-play').addEventListener('click', (e) => {
      e.preventDefault();

      $el.querySelector('.js-play').classList.add('hidden');
      $el.querySelector('.js-poster').classList.add('hidden');
      $el.querySelector('.js-video').classList.remove('hidden');
      $el.querySelector('.js-pause').classList.remove('hidden');

      $el.querySelector('.js-video').play();
    });

    $el.querySelector('.js-video').addEventListener('ended', () => {
      $el.querySelector('.js-play').classList.remove('hidden');
      $el.querySelector('.js-poster').classList.remove('hidden');
      $el.querySelector('.js-video').classList.add('hidden');
      $el.querySelector('.js-pause').classList.add('hidden');
    })

    $el.querySelector('.js-pause').addEventListener('click', (e) => {
      e.preventDefault();

      $el.querySelector('.js-play').classList.remove('hidden');
      $el.querySelector('.js-poster').classList.remove('hidden');
      $el.querySelector('.js-video').classList.add('hidden');
      $el.querySelector('.js-pause').classList.add('hidden');

      $el.querySelector('.js-video').pause();
    });
  }
}
